var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuStatsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 89,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 42a3 3 0 0 1 3-3h18.3a3 3 0 0 1 3 3v33H5.1V42ZM65.7 26a3 3 0 0 1 3-3h18.2a3 3 0 0 1 3 3v49H65.7V26ZM35.4 3a3 3 0 0 1 3-3h18.2a3 3 0 0 1 3 3v72H35.4V3Z",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 80,
    width: 96,
    height: 9,
    rx: 4.5,
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuStatsIcon);
export default __webpack_public_path__ + "static/media/menu-stats-icon.6427f5e5f02a0d67e6bb62da5aa561cd.svg";
export { ForwardRef as ReactComponent };